<script setup lang="ts">
const ref = useTemplateRef("main-content-link");

function unFocusEL() {
  ref.value?.blur();
}
</script>

<template>
  <a
    ref="main-content-link"
    href="#main-content"
    class="absolute -top-96 z-1000 flex min-h-24 w-full items-center justify-center bg-green-30 p-4 text-center text-xl text-white focus:top-0"
    @keyup.enter.stop="unFocusEL"
    @keyup.space.stop="unFocusEL"
    @click.stop="unFocusEL"
  >
    Hopp til hovedinnhold
  </a>
</template>
